import { useEffect, useState } from 'react';

import ChevronIcon from '@/app/assets/svg/arrow-banner.svg?react';
import CloseIcon from '@/app/assets/svg/close.svg?react';
import { useLatestProposal } from '@/app/components/VotingBanner/useLatestProposal';

const BANNER_DISMISSED_KEY = 'voting-banner-dismissed';

const VotingBanner = () => {
  const { proposal, isActive } = useLatestProposal();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (!proposal?.id) {
      setIsDismissed(false);
      return;
    }
    setIsDismissed(sessionStorage.getItem(`${BANNER_DISMISSED_KEY}:${proposal.id}`) === 'true');
  }, [proposal?.id]);

  if (!isActive || !proposal || isDismissed) return null;

  const handleClose = () => {
    sessionStorage.setItem(`${BANNER_DISMISSED_KEY}:${proposal.id}`, 'true');
    setIsDismissed(true);
  };

  const startDate = new Date(proposal.start * 1000).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const endDate = new Date(proposal.end * 1000).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  const snapshotUrl = `https://testnet.snapshot.box/#/s-tn:mezz.eth/proposal/${proposal.id}`;

  return (
    <div className='pointer-events-auto absolute top-full right-0 left-0 z-20 bg-[#234FAE] px-5 py-3 text-white md:px-[22px]'>
      <div className='flex w-full items-center justify-between'>
        <a
          href={snapshotUrl}
          target='_blank'
          rel='noreferrer'
          className='flex flex-wrap items-center gap-2 font-medium md:hidden'
        >
          <span className='leading-6 font-normal text-white/80'>The new voting on Snapshot</span>
          <span className='flex items-center gap-1 leading-6 font-medium whitespace-nowrap text-white'>
            Vote Now
            <ChevronIcon className='h-3 w-3' />
          </span>
        </a>

        <div className='hidden w-full items-center justify-center gap-x-5 font-medium md:flex'>
          <span className='text-base leading-6 font-normal text-white/80'>{proposal.title}</span>

          <span className='text-white'>•</span>

          <span className='text-base leading-6 font-normal whitespace-nowrap text-white/80'>
            {startDate} - {endDate}
          </span>

          <span className='text-white'>•</span>

          <a
            href={snapshotUrl}
            target='_blank'
            rel='noreferrer'
            className='flex items-center gap-2 leading-6 font-medium'
          >
            Vote Now
            <ChevronIcon className='h-3 w-3' />
          </a>
        </div>

        <button
          onClick={handleClose}
          className='shrink-0 text-white/60 transition-colors hover:text-white'
          aria-label='Close banner'
        >
          <CloseIcon className='h-4 w-4' />
        </button>
      </div>
    </div>
  );
};

export default VotingBanner;
